"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var React = require("react");
var Toggle_style_1 = require("./Toggle.style");
exports.Toggle = function (props) {
    var name = props.name, checked = props.checked, textLeft = props.textLeft, textRight = props.textRight, disabled = props.disabled, onChange = props.onChange;
    return (React.createElement(Toggle_style_1.default.Toggle, null,
        textLeft ? React.createElement(Toggle_style_1.default.TextLeft, null, textLeft) : null,
        React.createElement(Toggle_style_1.default.ThemeSwitch, { checked: checked, name: name, id: name, onChange: onChange, disabled: disabled, "aria-label": name }),
        React.createElement(Toggle_style_1.default.SwitchLabel, { htmlFor: name, disabled: disabled },
            React.createElement(Toggle_style_1.default.SwitchOverlay, null),
            React.createElement(Toggle_style_1.default.SwitchSlider, null)),
        textRight ? React.createElement(Toggle_style_1.default.TextRight, null, textRight) : null));
};
exports.default = exports.Toggle;
//# sourceMappingURL=Toggle.js.map